import { render } from "./HomHeaderSub.vue?vue&type=template&id=2f9c4b53&ts=true"
import script from "./HomHeaderSub.vue?vue&type=script&lang=ts"
export * from "./HomHeaderSub.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__